module.exports = __webpack_public_path__ + "static/media/blood4.93bed639.svg";